<template>
  <div class="home">
    <header>
      <div class="head">
        <div class="hleft">
          <div class="logo">
            <img src="../assets/pLogo.png" alt="" />
            <!-- <img src="../assets/logo.png" alt />
            <div class="cTitle">
              <h2>北京天蔚中医药发展促进中心</h2>
              <h4>BeijingTianweiPromotionCenter</h4>
            </div> -->
          </div>
        </div>
        <div class="hright">
          <div class="search">
            <el-input
              placeholder="请输入内容"
              suffix-icon="el-icon-search"
              @keyup.enter.native="search"
              v-model="keyword"
              style="width: 2.3rem"
            ></el-input>
            <div class="userInfo"></div>
            <!-- <div class="userInfo">
              <div class="lInfo" v-if="Object.keys(userInfo).length > 0">
                <el-dropdown
                  trigger="click"
                  placement="bottom"
                  @command="setDialogInfo"
                >
                  <span class="el-dropdown-link">
                    <img :src="userInfo.head" alt />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="info">个人信息</el-dropdown-item>
                    <el-dropdown-item command="password">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout"
                      >退出登录</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-else class="userlogin"></div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="mNav">
        <div class="mNavLeft">
          <ul ref="navUl">
            <li
              :style="
                index == nav.length - 1
                  ? index == navCurrentIndex
                    ? 'padding-right:0.3rem;color:#fe7333;'
                    : 'padding-right:0.3rem'
                  : index == navCurrentIndex
                  ? 'color:#fe7333;'
                  : ''
              "
              @click="toLink(item, index)"
              v-for="(item, index) in nav"
              :key="index"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="mNavRight">
          <i @click="drawer = true" class="el-icon-s-fold"></i>
        </div>
      </div>
    </header>
    <el-drawer
      size="50%"
      class="drawer"
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false"
    >
      <ul>
        <li
          :style="index == navCurrentIndex ? 'color:#fe7333;' : ''"
          @click="toLink(item, index)"
          v-for="(item, index) in nav"
          :key="index"
        >
          {{ item.title }}
        </li>
      </ul>
    </el-drawer>
    <div class="content">
      <keep-alive exclude="mNewsContent,mProgramDetail,mProgramContent">
        <router-view></router-view>
      </keep-alive>
    </div>
    <footer>
      <h1>
        北京天蔚中医药发展促进中心版权所有 | <a style="color: #fff; "  href="https://beian.miit.gov.cn">  京ICP备2020036376号-1 </a>
       
      </h1>
    </footer>
    <div class="mtop" ref="top" @click="goTop">
      <i class="el-icon-caret-top"></i>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Bus from "@/utils/bus.js";
import WOW from "wowjs";
import { getReCode, getBackCode } from "@/api/user.js";
export default {
  name: "Home",
  data() {
    let self = this;
    return {
      zoom: 12,
      center: [116.349634, 40.03402],
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      marker: {
        position: [116.349634, 40.03402],
      },
      address: "",
      events: {
        click(e) {
          let { lng, lat } = e.lnglat;
          self.lng = lng;
          self.lat = lat;
          self.marker.position = [lng, lat];
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all",
          });
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress;
                self.$nextTick();
              }
            }
          });
        },
      },
      lng: 0,
      lat: 0,
      nav: [
        {
          title: "首页",
          url: "mmain",
        },
        {
          title: "关于我们",
          url: "mconntect",
        },
        {
          title: "中心动态",
          url: "mNews",
        },
        {
          title: "信息公开",
          url: "mnewsInfo",
        },
        {
          title: "项目展示",
          url: "mprogram",
        },
        {
          title: "合作交流",
          url: "mJlzx",
        },
        {
          title: "公益捐赠",
          url: "mHzzx",
        },
      ],
      drawer: false,
      keyword: "",
      currentIndex: 0,
      navCurrentIndex: 0,
      moverIndex: -1,
      moverItem: {},
      userInfo: {},
    };
  },
  mounted() {
    this.getInfo();
    this.getCurrent();
    Bus.$on("getpCurrent", (e) => {
      this.getCurrent(e);
    });
    window.addEventListener("scroll", this.scrollToTop);
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true,
      });
      wow.init();
    }, 200);
  },
  methods: {
    // 点击跳转
    toLink(item, index) {
      this.drawer = false;
      this.$router.push({ name: item.url, params: { title: true } });
      this.navCurrentIndex = index;
      if (index > 2) {
        this.$refs.navUl.scrollLeft = 70 * (index - 3) + 50;
      } else {
        this.$refs.navUl.scrollLeft = 0;
      }
    },
    //返回顶部
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    // 检查是否被选中
    getCurrent(currentUrl) {
      this.nav.forEach((item, index) => {
        if (
          item.url ==
            window.location.pathname ||
          item.url == currentUrl
        ) {
          this.navCurrentIndex = index;
          if (index > 2) {
            this.$refs.navUl.scrollLeft = 70 * (index - 3) + 50;
          } else {
            this.$refs.navUl.scrollLeft = 0;
          }
          return false;
        }
      });
    },
    // 搜索
    search() {
      if (this.keyword) {
        // const sNew = this.$router.resolve({
        //   name: "search",
        //   query: { content: this.keyword }
        // });
        // this.keyword = "";
        // window.open(sNew.href, "_blank");
        this.$router.push({
          name: "mSearch",
          query: { keyword: this.keyword },
        });
        Bus.$emit("getpSearch");
        this.keyword = "";
      } else {
        this.$message.warning("搜索内容不能为空");
      }
    },
    //获取用户信息和是否登录
    getInfo() {
      this.userInfo = this.$store.state.user.userInfo;
      // this.$store.dispatch("checkToken");
      // this.isLogin = this.$store.state.isLogin;
      // this.userInfo = this.$store.state.userInfo;
      // if (this.userInfo.phone) {
      //   this.phone = this.userInfo.phone.replace(
      //     this.userInfo.phone.substring(3, 7),
      //     "****"
      //   );
      // }
    },
    // 滑动时触发
    scrollToTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let browserHeight = window.outerHeight; //浏览器页面高度
      if (scrollTop > browserHeight) {
        this.$refs.top.style.display = "block";
      } else {
        this.$refs.top.style.display = "none";
      }
    },
    setDialogInfo(cmditem) {
      if (!cmditem) {
        this.$message("菜单选项缺少command属性");
        return;
      }
      switch (cmditem) {
        case "info":
          // if (this.$store.state.isLogin) {
          this.showInfoList();
          // } else {
          //   this.$message.warning("当前用户身份过期，请退出重新登录");
          // }
          break;
        case "password":
          if (this.$store.state.isLogin) {
            this.editPass();
          } else {
            this.$message.warning("当前用户身份过期，请退出重新登录");
          }
          break;
        case "logout":
          this.logout();
          break;
      }
    },
    showInfoList() {
      // 个人信息
      this.$router.push("/userInfo");
    },
    //退出登录
    logout() {
      // 清除token
      localStorage.removeItem("Token");
      this.$store.commit("user/getUserInfo", {});
      this.getInfo();
      // // 页面跳转
      // this.getCookie();
      // this.$router.push("/pmain");
    },
  },
  components: {},
  //退出时移除事件
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
};
</script>

<style lang="less" scoped>
@color: #512475;
.info {
  margin-left: 30px;
  line-height: 2;

  h2 {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
  }

  p {
    font-size: 14px;
    color: #666;
  }

  .line {
    width: 130px;
    height: 2px;
    margin-left: -20px;
    background-color: #555;
  }
}

.home {
  width: 100%;
  .mtop {
    i {
      width: 72px;
      height: 72px;
      position: fixed;
      right: 30px;
      bottom: 60px;
      border: 1px solid #ccc;
      border-radius: 50%;
      font-size: 36px;
      color: #4ccaff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    i:hover {
      color: #fff;
      background-color: #4accff;
    }
  }

  .v-enter {
    opacity: 0;
  }
  .v-enter-active {
    transition: 0.5s;
  }
  .v-enter-to {
    opacity: 1;
  }
  .v-leave {
    opacity: 1;
  }
  .v-leave-to {
    opacity: 0;
  }
  .v-leave-active {
    transition: 0.5s;
  }
  header {
    height: 150px;
    width: 100%;
    position: fixed;
    z-index: 100;
    background-color: #fff;
    top: 0;
    left: 0;
    .head {
      height: 70px;
      display: flex;
      justify-content: space-between;
      .hleft {
        width: 360px;
        height: 70px;
        display: flex;
        align-items: center;
        margin-left: 30px;
        .logo {
          margin-right: 15px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          img {
            width: 360px;
            height: 60px;
          }
          .cTitle {
            margin-left: 4px;
            h2 {
              font-size: 14px;
              font-weight: bolder;
              margin-bottom: 4px;
            }
            h4 {
              font-size: 11px;
            }
          }
        }
      }
      .hright {
        height: 70px;
        .search {
          width: 250px;
          height: 70px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .userInfo {
            margin-left: 20px;
            margin-right: 30px;
            .userlogin {
              font-size: 14px;
              color: #fff;
              span {
                cursor: pointer;
              }
            }
            .lInfo {
              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .mNav {
      display: flex;
      justify-content: space-between;
      height: 80px;
      align-items: center;
      .mNavLeft {
        margin-left: 30px;
        ul {
          width: calc(100vw - 110px);
          height: 80px;
          white-space: nowrap;
          overflow-x: scroll;
          overflow-y: hidden;
          -webkit-backface-visibipty: hidden;
          -webkit-perspective: 1000;
          -webkit-overflow-scrolpng: touch;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          &::-webkit-scrollbar {
            display: none;
          }
          li {
            font-size: 26px;
            color: #212121;
            margin-right: 40px;
          }
        }
      }
      .mNavRight {
        width: 50px;
        height: 80px;
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-right: 30px;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          width: 30px;
          height: 80px;
          background-color: #fff;
          filter: blur(10px);
          left: -30px;
        }
        i {
          font-size: 34px;
          color: #000;
        }
      }
    }
  }
  .drawer {
    ul {
      li {
        margin-top: 50px;
        font-size: 30px;
        text-align: center;
      }
    }
  }
  .content {
    min-height: calc(100vh - 300px);
  }
  footer {
    width: 100%;
    background-color: #3b3b3b;
    padding-bottom: 50px;
    padding-top: 50px;
    h1 {
      color: #fff;
      font-size: 26px;
      text-align: center;
      width: 80%;
      margin: 0 auto;
      line-height: 1.2;
    }
  }
}
</style>
